<template>
  <div
    class="comp-banner"
    :style="data.pic ? 'background-image:url(' + data.pic + ')' : ''"
  >
    <div class="g-wrap">
      <h2>{{ data.name }}</h2>
      <h3>{{ data.enName }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "ic-banner",
  props: {
    data: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-banner {
  height: 160px;
  background: url(/static/img/banner.png) no-repeat center top;
  background-size: 100% 100%;
  h2 {
    font-size: 30px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 45px;
    padding-top: 47px;
  }
  h3 {
    font-size: 18px;
    font-family: HelveticaNeue;
    color: rgba(255, 255, 255, 0.35);
    line-height: 24px;
    text-transform: uppercase;
    font-weight: normal;
  }
}
</style>
